import * as microsoftTeams from '@microsoft/teams-js';
import { useEffect, useState } from 'react';

import { useQueryLocalApp } from 'gql/queries/local';
import { useQueryMe } from 'gql/queries/me';

const useSiteContext = () => {
  const [expoPushToken] = useState(() => {
    try {
      return window.expoPushToken;
    } catch (e) {
      return null;
    }
  });
  const [isInFrame] = useState(() => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  });
  const [isInNative] = useState(() => {
    try {
      return !!window.isInNative;
    } catch (e) {
      return false;
    }
  });
  const [isInTeams, setInTeams] = useState(false);
  useEffect(() => {
    try {
      microsoftTeams.initialize(() => {
        setInTeams(true);
      });
    } catch (e) {
      //
    }
  }, []);
  const {
    data: {
      app: { isAuthenticated },
    },
  } = useQueryLocalApp();
  const { data, isLoading } = useQueryMe({
    skip: !isAuthenticated,
  });
  const isGAR =
    !isAuthenticated || isLoading ? false : data.me.tags.includes('gar');
  const isTNECanope =
    !isAuthenticated || isLoading ? false : data.me.tags.includes('tne-canope');
  const isRoleTeacher =
    !isAuthenticated || isLoading ? false : data.me.role === 'teacher';
  const isRoleStudent =
    !isAuthenticated || isLoading ? false : data.me.role === 'student';
  return {
    expoPushToken,
    isInFrame,
    isInNative,
    isInTeams,
    isExternal: isInFrame || isInTeams,
    isGAR,
    isTNECanope,
    isRoleTeacher,
    isRoleStudent,
  };
};

export default useSiteContext;
